<template>
  <div class="apply-return">
    <div class="goodsStyle acea-row row-between" v-for="(item,key) in goodsList" :key="key" >
      <div class="pictrue">
        <img :src="item.cart_info.productInfo.image" class="image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">
			<p>{{ item.cart_info.productInfo.store_name }}</p>
			<p v-if="item.cart_info.productInfo.attrInfo">{{ item.cart_info.productInfo.attrInfo.suk }}</p>
			<p v-if="item.cart_info.spec_values">{{ item.cart_info.spec_values }}</p>
		</div>
        <div class="money">
          <div>￥{{ item.cart_info.truePrice }}</div>
          <div class="num">x {{ item.cart_info.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>售后方式</div>
        <div class="num">仅退款</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款原因</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">请选择</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text"
              :key="index"
            >
              {{ text }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
	  <div class="h"></div>
	  <div class="item acea-row row-between-wrapper">
	    <div style="width: 20%;">退款金额</div>
		<span class="refund-num">
			￥<input type="number" v-model="refunds_price" @keyup="refundNum()" :disabled="goodsList.length > 1 ? true : false">
			<!-- <i
			  v-if="goodsList.length > 1" 
			  @click="$router.push('/order/batch_refund/'+id)" 
			  class="iconfont icon-jiantou"
			></i> -->
		</span>
	    <!-- <div class="num">￥{{ orderInfo.pay_price }}</div> -->
	  </div>
	  <div class="h">最多可退￥{{ refund_amount }}<span v-if="coupon_price">（已扣除优惠券金额{{coupon_price}}）</span>，退款将返还实际支付金额</div>
      <div class="item acea-row row-between-wrapper">
        <div>手机号码</div>
        <div class="num">
			<input type="number" v-model="user_phone" pattern="[0-9]*" placeholder="请输入手机号码" >
		</div>
      </div>
	  <div class="item textarea acea-row row-between">
        <div>退款说明</div>
        <textarea
          placeholder="选填，最多100字"
          class="num"
          v-model="refund_reason_wap_explain"
		  maxlength="100"
        ></textarea>
      </div>
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>上传凭证</div>
          <div class="tip">( 最多可上传3张 )</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="index"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div>
    <button type="button" class="returnBnt bg-color-red displayblock" @click="submit" :disabled="isDisabled">申请退款</button>
  </div>
</template>

<script>
import { orderDetail, RefundReason, OrderRefund, getRefundGoods } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "OnlyRefund",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
	  goodsList: [],
	  orderid: "",
	  refund_amount:"",
	  coupon_price:"",
	  user_phone:"",
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      reasonList: [],
	    refunds_price:"",
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
     isDisabled:false,
    };
  },
  watch: {
    $route(n) {
	  if(n.name == 'OnlyRefund'){this.getRefundGoods();}
    }
  },
  mounted() {
  	this.getRefundGoods();
    this.getRefundReason();
  },
  methods: {
	//商品详情
	getRefundGoods(){
		let that = this;
		let unique = that.$route.params.id;
		getRefundGoods(unique).then(res => {
			that.goodsList = res.data.cartInfo;
			that.orderid = res.data.order_id;
			that.refund_amount = parseFloat(res.data.refund_amount);
			that.coupon_price = res.data.coupon_price;
			that.refunds_price = parseFloat(res.data.refund_amount);
			that.user_phone = res.data.user_phone;
		}).catch(err => {
			that.$dialog.error(err.msg);
			setTimeout(function(){
				that.$router.go(-1);
			},1000)
		});
	},
	//填写退款金额-失去焦点时间
	refundNum(){
		let refunds_price = parseFloat(this.refunds_price);
		let refund_amount = parseFloat(this.refund_amount);
		if(refunds_price > refund_amount){
			this.$dialog.toast({mes:'所填金额不能多于最多退款金额'});
			this.refunds_price = this.refund_amount;
		}
	},
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    getRefundReason() {
      RefundReason(1).then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
	  let that =this;
    const refund_reason_wap_explain = trim(that.refund_reason_wap_explain);
	  let submitList = {};
	  that.goodsList.forEach(item => {
		  submitList[item.unique] = item.refund_amount;
	  });
	  if (!that.reason)return that.$dialog.toast({ mes: "请选择退款原因" });
     that.isDisabled = true;
	  //console.log(submitList)
      OrderRefund({
        unique: that.$route.params.id,
		refunds_type: 1,
		refunds_price: that.goodsList.length == 1 ? that.refunds_price : submitList,
		refunds_reason_wap: that.reason,
		refunds_explain: refund_reason_wap_explain,
        refunds_voucher: that.refund_reason_wap_img.join(","),
        user_phone: that.user_phone
      })
        .then(res => {
          that.$dialog.success(res.msg);
		  if(that.goodsList.length == 1){
			that.$router.push('/order/refund_status/' + that.$route.params.id);
		  }else{
			that.$router.push('/order/detail/' + that.orderid);
		  }
        })
        .catch(res => {
          that.isDisabled = false;
          that.$dialog.error(res.msg);
        });
    }
  },
  
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.h{background-color: #f5f5f5;width: 100%;padding: 0.09rem 0 0.09rem 0.3rem;color: #999;font-size: 0.26rem;}
.refund-num{width: 80%;color: #ed1c1f;}
.refund-num input{color: #ed1c1f;}
.refund-num .iconfont{
	float: right;
	color: #666;
	font-size: 0.3rem;
	margin-top: 0.07rem;
}
.num input{text-align: right;}
.goodsStyle .text .name{width: 4.2rem;}
@media screen and (min-width:960px){
	.h{padding: 0.04rem 0 0.04rem 0.15rem;font-size: 0.13rem;}
	.refund-num .iconfont{
		font-size: 0.15rem;
		margin-top: 0.03rem;
	}
	.refund-num-cut,.refund-num-add{padding: 0.05rem 0.1rem;}
	.refund-num-input{width: 0.45rem;padding: 0.05rem 0;margin: 0 0.02rem;}
	.goodsStyle .text .name{width: 2.1rem;}
}
</style>
